import SettingProxy from "@/proxies/SettingProxy";
import types from "./mutation-types";
import loadingTypes from "@/store/mutation-types";


const initNewSettingsForSchduler = ({ commit }: any) => {
    commit(types.INIT_NEW_SETTINGS_FOR_SCHEUDLE);
};

const executeScheduler = ({ commit }: any, { data, callback }: any) => {
    commit(loadingTypes.START_LOADING);
    new SettingProxy().executeScheduler(data).then((response: any) => {
        commit(types.CREATE_SCHEDULER_SUCCESS, response);
        commit(loadingTypes.END_LOADING);
        // alert.methods.appToaster({ message: msgConstants.RESTAURANT_CREATE_SUCCESS, type: "SUCCESS" });
        callback();
    }).catch((error: any) => {
        commit(types.SCHEDULER_FAIL, error);
        // alert.methods.appToaster({ message: error.error.message, type: "ERROR" });
        commit(loadingTypes.END_LOADING);
    });
}

const setScheduler = ({ commit }: any, scheduler: any) => {
  commit(types.SET_SCHEDULER, scheduler);
};

const getScheduledHistory = ({ commit }: any, data: any) => {
    commit(loadingTypes.START_LOADING);
    new SettingProxy().getScheduledHistory(data).then((response: any) => {
      commit(types.LIST_SCHEDULER_SUCCESS, response);
      commit(loadingTypes.END_LOADING);
    }).catch((error: any) => {
      commit(types.SCHEDULER_FAIL, error.error);
     // alert.methods.appToaster({ message: error.error.message, type: "ERROR" });
      commit(loadingTypes.END_LOADING);
    });
  };


export default {
    initNewSettingsForSchduler,
    executeScheduler,
    setScheduler,
    getScheduledHistory
}